__turbopack_context__.v({
  "subtitle": "text-chat-module__PYFbwq__subtitle",
  "title": "text-chat-module__PYFbwq__title",
});
